import { useLang } from "@/i18n/LanguageContext";

export default function LevelsOfCareSection() {
  const { t } = useLang();

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      {/* Header */}
      <div className="text-center mb-16">
        <h2 className="text-4xl lg:text-5xl font-bold font-allura text-primary-500 mb-4">
          {t.levelsOfCare.title}
        </h2>
        <p className="text-xl text-text-secondary max-w-3xl mx-auto mb-6">
          {t.levelsOfCare.subtitle}
        </p>
        <p className="text-lg text-text-secondary max-w-4xl mx-auto">
          {t.levelsOfCare.description}
        </p>
      </div>

      {/* Features Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
        {t.levelsOfCare.features.map((feature, index) => (
          <FeatureCard key={index} {...feature} />
        ))}
      </div>

      {/* All-Inclusive Services */}
      <div className="bg-primary-100 rounded-2xl shadow-xl p-8 md:p-12 border border-primary-200">
        <h3 className="text-3xl font-bold font-allura text-primary-500 mb-8 text-center">
          {t.levelsOfCare.allInclusiveServices.title}
        </h3>
        <div className="grid md:grid-cols-2 gap-4">
          {t.levelsOfCare.allInclusiveServices.services.map((service, index) => (
            <ServiceItem key={index} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FeatureCard({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className="bg-accent-50 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 p-6 border border-secondary-200">
      <div className="flex items-start">
        <svg
          className="w-6 h-6 text-primary-600 mr-3 flex-shrink-0 mt-1"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <div>
          <h4 className="text-lg font-semibold text-text-primary mb-2">
            {title}
          </h4>
          <p className="text-text-secondary text-sm leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}

function ServiceItem({ service }: { service: string }) {
  return (
    <div className="flex items-start">
      <svg
        className="w-5 h-5 text-primary-600 mr-3 flex-shrink-0 mt-0.5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 13l4 4L19 7"
        />
      </svg>
      <span className="text-text-secondary">{service}</span>
    </div>
  );
}
